{
  "version": 1,
  "asset_id": "f16c0d28-f19e-4d9f-984e-d1c38947b12b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f16c0d28-f19e-4d9f-984e-d1c38947b12b/hiatal-type-1-es-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f16c0d28-f19e-4d9f-984e-d1c38947b12b/hiatal-type-1-es-v3-1200.webp",
  "original_filename": "hiatal-type-1-es-v3-1200.webp",
  "size": 134656,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:09:22Z"
}
